export default "/static/assets/load.4cd3d50e0abba3cf19d111e22343bb1e.svg";